import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsAndConditionsType, TermsAndConditionsService, MemberQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil, map, switchMap, tap } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc4 from '@ngx-translate/core';

function TermsAndConditionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.termsAndConditions.BodyText), ɵngcc0.ɵɵsanitizeHtml);
} }
function TermsAndConditionsComponent_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "terms.default"), "");
} }
function TermsAndConditionsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 4);
    ɵngcc0.ɵɵtemplate(1, TermsAndConditionsComponent_ng_template_2_ng_container_1_Template, 3, 3, "ng-container", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.defaultTerms);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.defaultTerms);
} }
class TermsAndConditionsComponent {
    constructor(termsAndConditionsService, memberQuery) {
        this.termsAndConditionsService = termsAndConditionsService;
        this.memberQuery = memberQuery;
        this.type = TermsAndConditionsType.General;
        this._isDestroyed$ = new Subject();
    }
    ngOnInit() {
        this.memberQuery.userContext$
            .pipe(takeUntil(this._isDestroyed$), map((user) => user && user.lcid), switchMap((lcid) => this.termsAndConditionsService.getTermsAndConditions(this.type, lcid).pipe(tap((terms) => {
            this.termsAndConditions = terms[0];
        }))))
            .subscribe();
    }
    ngOnDestroy() {
        this._isDestroyed$.next();
        this._isDestroyed$.complete();
    }
}
TermsAndConditionsComponent.ɵfac = function TermsAndConditionsComponent_Factory(t) { return new (t || TermsAndConditionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TermsAndConditionsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery)); };
TermsAndConditionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TermsAndConditionsComponent, selectors: [["fgbcl-terms-and-conditions"]], inputs: { type: "type", defaultTerms: "defaultTerms" }, decls: 4, vars: 2, consts: [[1, "terms-section-box", "rounded", "px-4", "py-3"], ["class", "terms-section-content text-left mb-3", 3, "innerHtml", 4, "ngIf", "ngIfElse"], ["defaultTemplate", ""], [1, "terms-section-content", "text-left", "mb-3", 3, "innerHtml"], [3, "ngTemplateOutlet"], [4, "ngIf"]], template: function TermsAndConditionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TermsAndConditionsComponent_div_1_Template, 2, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, TermsAndConditionsComponent_ng_template_2_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.termsAndConditions)("ngIfElse", _r1);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc3.SafeHtmlPipe, ɵngcc4.TranslatePipe], styles: [""] });
TermsAndConditionsComponent.ctorParameters = () => [
    { type: TermsAndConditionsService },
    { type: MemberQuery }
];
TermsAndConditionsComponent.propDecorators = {
    type: [{ type: Input }],
    defaultTerms: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TermsAndConditionsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-terms-and-conditions',
                template: "<div class=\"terms-section-box rounded px-4 py-3\">\r\n  <div\r\n    *ngIf=\"termsAndConditions; else defaultTemplate\"\r\n    class=\"terms-section-content text-left mb-3\"\r\n    [innerHtml]=\"termsAndConditions.BodyText | safeHtml\"\r\n  ></div>\r\n  <ng-template #defaultTemplate>\r\n    <ng-container [ngTemplateOutlet]=\"defaultTerms\"></ng-container>\r\n    <ng-container *ngIf=\"!defaultTerms\"> {{ 'terms.default' | translate }}</ng-container>\r\n  </ng-template>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.TermsAndConditionsService }, { type: ɵngcc1.MemberQuery }]; }, { type: [{
            type: Input
        }], defaultTerms: [{
            type: Input
        }] }); })();

class TermsAndConditionsModule {
}
TermsAndConditionsModule.ɵfac = function TermsAndConditionsModule_Factory(t) { return new (t || TermsAndConditionsModule)(); };
TermsAndConditionsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TermsAndConditionsModule });
TermsAndConditionsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TermsAndConditionsModule, { declarations: function () { return [TermsAndConditionsComponent]; }, imports: function () { return [CommonModule,
        PipesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [TermsAndConditionsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TermsAndConditionsModule, [{
        type: NgModule,
        args: [{
                declarations: [TermsAndConditionsComponent],
                imports: [
                    CommonModule,
                    PipesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [TermsAndConditionsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TermsAndConditionsComponent, TermsAndConditionsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-club-terms-and-conditions.js.map